














































import Vue from 'vue';
import TeamSelect from '../../layout/inputs/TeamSelect.vue';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import VoucherAssignmentFailedMessage from './VoucherAssignmentFailedMessage.vue';

interface ICodeBasedVoucherAssignmentComponent {
  selectedCustomerName: string;
  selectedCustomerNumber: number;
}

export default Vue.extend({
  components: { CustomButton, TeamSelect, VoucherAssignmentFailedMessage },
  data(): ICodeBasedVoucherAssignmentComponent {
    return {
      selectedCustomerName: ``,
      selectedCustomerNumber: -1,
    };
  },
  props: {
    showAssignmentError: {
      default: false,
      type: Boolean,
    },
    voucherValue: {
      required: true,
      type: Number,
    },
  },
  methods: {
    selectCustomer(customer: { customerNumber: number; label: string }): void {
      this.selectedCustomerName = customer.label.substr(0, customer.label.indexOf(` - `));
      this.selectedCustomerNumber = customer.customerNumber;
    },
  },
});
